/** Textos fijos de la pantalla. El sistema no presenta un criterio oficial del SAT. */

export const LEYENDAS_ANALISIS = [
  "Los rangos de referencia no son criterios oficiales del SAT. El SAT no publica porcentajes de razonabilidad de gastos por giro.",
  "Las referencias provienen de estadística pública agregada (INEGI, Censos Económicos) o de criterios del propio despacho, según se indica en la columna Fuente. Son promedios sectoriales, no límites legales.",
  "Un rubro en amarillo no significa que el gasto no sea deducible. La deducibilidad depende de los requisitos de la Ley del ISR y de la materialidad documentada.",
  "El coeficiente del artículo 58 del CFF es la utilidad que la autoridad puede aplicar en una determinación presuntiva. Se muestra solo como contexto y no alimenta el semáforo.",
  "Las filas marcadas EJEMPLO no tienen fuente verificada. Reemplácelas antes de usarlas con clientes. Una fila EJEMPLO no se pinta en rojo.",
  "Referencia estadística, no es criterio de la autoridad.",
];

export const MARCA_EJEMPLO = "EJEMPLO – llenar con dato real";

export const PESTANAS_ANALISIS = [
  { id: "configuracion", etiqueta: "Configuración de datos" },
  { id: "gastos", etiqueta: "Gastos razonables" },
  { id: "proyectado", etiqueta: "Proyectado al cierre" },
];
